import { LoadingScreen } from "@flat-ui";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { SettingsTabs } from "@router/route-params";
import { HAS_CREDIT_PURCHASED } from "@src/constants/credit-constants";
import { useCompanyId } from "@context-providers/company-id-provider";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useEffect } from "react";

/**
 * It is a test component that simulates a successful credit purchase.
 * Renders a success page after purchasing credits.
 * Displays a success message and navigates to the subscription settings page.
 */
export function CreditsPurchaseRedirection(): JSX.Element {
  const { trackEvent } = useTrackEvent();
  const { navigateToSettingsPage } = useAppNavigation();
  const companyId = useCompanyId();

  useEffect(() => {
    localStorage.setItem(HAS_CREDIT_PURCHASED, "true");

    // Track the event when the user get redirected to application after purchasing credits
    trackEvent({
      name: WorkspaceEvents.purchaseCreditsSuccess,
    });

    navigateToSettingsPage({
      companyId,
      settingsTab: SettingsTabs.subscription,
    });
  }, [companyId, navigateToSettingsPage, trackEvent]);

  return <LoadingScreen />;
}
